import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import {
  FeedbackSource,
  FeedbackStatus,
  ICustomerFeedback,
  IFeedbackStats,
  IUpdateFeedbackStatus
} from "../interfaces/endpoints/ICustomerFeedback";
import { serialize } from "../utils/serializeToQueryString";

// Query-string parameters accepted by the admin list endpoint. All
// fields optional — defaults give the BD landing view (newest first,
// any source / status, page 1).
export type GetAllFeedbackParamsType = {
  source?: FeedbackSource;
  status?: FeedbackStatus;
  // Free-text contains-match against either origin or destination.
  route?: string;
  // ISO timestamps. We don't constrain to YYYY-MM-DD here — the
  // useSearch hook serialises whatever the date picker emits.
  dateFrom?: string;
  dateTo?: string;
  hasEmail?: boolean;
  pageIndex?: number;
  pageSize?: number;
  // Inherited from useSearch's auto-injected params; harmless on the
  // backend side because EF binding ignores unknown query keys.
  searchkeyword?: string;
};

export const getAllFeedback = async (
  params: GetAllFeedbackParamsType
): Promise<IAxiosResponse<ICustomerFeedback[]>> => {
  // Backend exposes both `/api/UserFeedback/Get` and the explicit
  // versioned `/api/v1/UserFeedback/Get` via dual [Route] attributes;
  // we use the versioned form to match the rest of Travel.Admin's
  // service layer (see VoucherCode.service.ts, etc.).
  return axios.get<ICustomerFeedback[]>(
    `/v1/UserFeedback/Get${serialize(params)}`
  );
};

export const getFeedbackById = async (
  id: number
): Promise<IAxiosResponse<ICustomerFeedback>> => {
  return axios.get(`/v1/UserFeedback/Detail/${id}`);
};

export const updateFeedbackStatus = async (
  id: number,
  body: IUpdateFeedbackStatus
): Promise<IAxiosResponse<unknown>> => {
  // Backend returns 204 No Content on success — there's nothing to
  // surface to the consumer beyond the HTTP status. We still wrap in
  // IAxiosResponse for parity with the other service signatures.
  return axios.put(`/v1/UserFeedback/Status/${id}`, body);
};

export const getFeedbackStats = async (): Promise<
  IAxiosResponse<IFeedbackStats>
> => {
  return axios.get("/v1/UserFeedback/Stats");
};
